import React from 'react'

const FontsSG = () => {
    return (
        <div>
            <div className="row">
                <div className="small-12 columns">
                    <p className="font-sans-serif">
                        <strong>Sans Serif Font:</strong> &apos;Cairo&apos;,
                        Arial, sans-serif; <kbd>$sans-serif</kbd>
                    </p>
                    <p className="font-sans-serif">
                        <kbd>400</kbd>{' '}
                        <span className="font-400">
                            The five boxing wizards jump quickly.{' '}
                            <em>
                                Brawny gods just flocked up to quiz and vex him.
                            </em>
                        </span>
                        <br />
                        <kbd>700</kbd>{' '}
                        <span className="font-700">
                            The five boxing wizards jump quickly.{' '}
                            <em>
                                Brawny gods just flocked up to quiz and vex him.
                            </em>
                        </span>
                        <br />
                        <kbd>800</kbd>{' '}
                        <span className="font-800">
                            The five boxing wizards jump quickly.{' '}
                            <em>
                                Brawny gods just flocked up to quiz and vex him.
                            </em>
                        </span>
                        <br />
                    </p>
                </div>
            </div>
            <div className="spacer-small" />
            {/* <div className="row">
                <div className="small-12 columns">
                    <p className="font-sans-serif-condensed"><strong>Sans Serif Condensed Font:</strong> 'Roboto Condensed', Arial, sans-serif; <kbd>$sans-serif-condensed</kbd></p>
                    <p className="font-sans-serif-condensed">
                        <kbd>400</kbd> <span className="font-400">The five boxing wizards jump quickly. <em>Brawny gods just flocked up to quiz and vex him.</em></span><br />
                        <kbd>700</kbd> <span className="font-700">The five boxing wizards jump quickly. <em>Brawny gods just flocked up to quiz and vex him.</em></span><br />
                    </p>
                </div>
            </div> */}
        </div>
    )
}

export default FontsSG
